import { createExperiment } from 'shared/experiment/hook';

export type FhhExperiments = { [key: string]: string };

const { ExperimentProvider, useExperiment } = createExperiment<FhhExperiments>();

export { ExperimentProvider, useExperiment };
